<template>
  <div id="weeklyReport" element-loading-background="rgba(255, 255, 255, 0.4)">
    <el-form :model="weeklyReportCusForm" ref="weeklyReportCusForm" labelWidth="0px">
      <el-collapse v-model="activeNames">
        <el-collapse-item title="Basic Information of Project" name="1">
          <el-row>
            <el-col :span="0">
              <el-form-item prop="majorProjectId">
                <el-input  v-model="weeklyReportCusForm.majorProjectId" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :xs="24" :md="12">
              <el-form-item label="Project Manager:" prop="projectManager" :rules="[{ required: true, message: 'Please input'}]" labelWidth="141px">
                <el-input v-model="weeklyReportCusForm.projectManager" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col  :xs="24" :md="12">
              <el-form-item label="Technical Manager:" prop="technicalManager" :rules="[{ required: true, message: 'Please input'}]" labelWidth="160px">
                <el-input v-model="weeklyReportCusForm.technicalManager" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="" prop="projectOverview" :rules="[{ required: true, message: 'Please input'}]">
                <el-input type="textarea" clearable :autosize="{ minRows: 2, maxRows: 6 }" disabled v-model="weeklyReportCusForm.projectOverview" maxlength="255" placeholder="Please input" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-collapse-item>
        <el-collapse-item title="Overall Project Progress" name="2">
          <el-row>
            <el-col :span="24">
              <el-form-item label="" prop="overallProjectProgress" :rules="[{ required: true, message: 'Please input'}]">
                <el-input type="textarea" clearable :autosize="{ minRows: 2, maxRows: 6 }" disabled v-model="weeklyReportCusForm.overallProjectProgress" maxlength="255" placeholder="Please input" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-collapse-item>
        <el-collapse-item title="Escalate and Help" name="3" v-if="weeklyReportCusForm && weeklyReportCusForm.helpList && weeklyReportCusForm.helpList.length > 0">
          <el-table :data="weeklyReportCusForm.helpList" border class="week-table" size="small" tooltip-effect="dark" :header-cell-style="{background:'#F5F5F9'}">
            <el-table-column prop="escalateDescription" align="center" label="Escalate description"></el-table-column>
            <el-table-column prop="theDepartmentThatIsSeekingHelp" align="center" label="The department that is seeking help"></el-table-column>
            <el-table-column prop="theTimeOfResolution" align="center" width="200" label="The time of resolution"></el-table-column>
          </el-table>
        </el-collapse-item>
        <el-collapse-item title="Risk Management" name="4" v-if="weeklyReportCusForm && weeklyReportCusForm.riskList && weeklyReportCusForm.riskList.length > 0">
          <el-table :data="weeklyReportCusForm.riskList" border  class="week-table" size="small" tooltip-effect="dark" :header-cell-style="{background:'#F5F5F9'}">
            <!-- <el-table-column prop="riskTypeDesc" width="150" label="Risk Type"></el-table-column> -->
            <el-table-column prop="riskLevel" width="200" label="Risk Level"></el-table-column>
            <el-table-column prop="riskDescription" min-width="350" label="Risk Description"></el-table-column>
            <el-table-column prop="responseMeasures" width="350" label="Response Measures"></el-table-column>
            <el-table-column prop="owner" width="180" label="Owner"></el-table-column>
            <el-table-column prop="plannedClosingDate" width="180" label="Planned Closing Date"></el-table-column>
          </el-table>
        </el-collapse-item>
        <el-collapse-item title="Weekly Progress" name="5">
          <el-row>
            <el-col :span="24">
              <el-form-item label="Weekly Report Period:" labelWidth="170px" prop="weeklyStartEndDate" :rules="[{ required: true, message: 'Please input'}]">
                <el-date-picker
                  v-model="weeklyReportCusForm.weeklyStartEndDate"
                  type="daterange"
                  range-separator="-"
                  start-placeholder=""
                  end-placeholder=""
                  disabled
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-table :data="weeklyReportCusForm.thisWeekWorkProgressList" border class="week-table" size="small" tooltip-effect="dark" :header-cell-style="{background:'#F5F5F9'}">
            <el-table-column label="No." type="index" sortable width="85" align="center"></el-table-column>
            <el-table-column prop="jobContent" label="Tasks Completed" align="center"></el-table-column>
          </el-table>
          <h3 style="width: 20px; height: 15px;"></h3>
          <el-table :data="weeklyReportCusForm.nextWeekWorkProgressList" border class="week-table" size="small" tooltip-effect="dark" :header-cell-style="{background:'#F5F5F9'}">
            <el-table-column label="No." type="index" sortable width="85" align="center"></el-table-column>
            <el-table-column prop="jobContent" label="Next Week Plan" align="center"></el-table-column>
          </el-table>
        </el-collapse-item>
        <el-collapse-item title="Project Milestone" name="6" v-if="weeklyReportCusForm && weeklyReportCusForm.milestoneList && weeklyReportCusForm.milestoneList.length > 0">
          <el-table :data="weeklyReportCusForm.milestoneList" border class="milestone-table" tooltip-effect="dark" :header-cell-style="{background:'#F5F5F9'}">
            <el-table-column prop="keyTask" min-width="220" label="Key Task"></el-table-column>
            <el-table-column prop="keyTaskDesc" min-width="220" label="Key Task Description"></el-table-column>
            <el-table-column prop="progressPercentage" label="Progress Percentage (%)" min-width="180"></el-table-column>
            <el-table-column prop="currentStatus" min-width="180" label="Current Status"></el-table-column>
            <el-table-column prop="startDate" label="Start Date" min-width="150"></el-table-column>
            <el-table-column prop="endDate" min-width="150" label="End Date"></el-table-column>
          </el-table>
        </el-collapse-item>
      </el-collapse>
    </el-form>
  </div>
</template>
<script>
import moment from 'moment';
  export default {
    name: 'weeklyReportHis',
		props: {
			id: {
        type: Number,
        default: null,
      },
      historyWeeklyData: {
				type: Object,
        default: {}
      }
		},
		watch: {
      // historyWeeklyData(newValue, oldValue) {
      //   console.log('newValue', newValue)
			// 	this.getSelectInfo();
			// }
		},
    created () {
      // this.getSelectInfo();
      this.getWeeklyInfo();
    },
    data () {
      return {
        moment,
        activeNames: ['1', '2', '3', '4', '5', '6'],
        weeklyReportCusForm: {},
        projectManagerList: [],
        majorProjectLevel: [],
        customerIndustry: [],
        developmentLeaderList: [],
        riskLevel: [],
        riskData: [],
        ganttDta: [],
        allData: {},
      }
    },
    methods: {
			getWeeklyInfo() {
        const data = this.historyWeeklyData;
        let nextWeekWorkProgressListNew = [];
        let thisWeekWorkProgressListNew = [];
        data.nextWeekWorkProgressList && data.nextWeekWorkProgressList.forEach(item => {
          nextWeekWorkProgressListNew.push({
            jobContent: item,
          })
        })
        data.thisWeekWorkProgressList && data.thisWeekWorkProgressList.forEach(item => {
          thisWeekWorkProgressListNew.push({
            jobContent: item,
          })
        })
        this.weeklyReportCusForm = {
          ...data,
          nextWeekWorkProgressList: nextWeekWorkProgressListNew.length === 0 ? [{}] : nextWeekWorkProgressListNew,
          thisWeekWorkProgressList: thisWeekWorkProgressListNew.length === 0 ? [{}] : thisWeekWorkProgressListNew,
          projectStartEndDate: [data.projectPlanStartDate, data.projectPlanEndDate],
          weeklyStartEndDate: data.reportStartDate ? [data.reportStartDate, data.reportEndDate] : [],
        }
			},
			getSelectInfo() {
				let url = `${this.$store.state.islhurl}configMain/queryLabelList?`;
				let configKeyList = [
					'majorProjectLevel',
					'customerIndustry',
          'riskLevel',
				]
				let str = '';
				configKeyList.forEach(item => {
					str += `&configKeyList=${item}`;
				})
				url = url + str.substring(1)
				const _this = this
				this._post(url).then(
					res => {
						if (res.data && res.code === 200) {
							Object.keys(res.data).forEach(function(key) {
								_this[key] = res.data[key];
							});
						}
					}
				)
			},
    },
  }
</script>
<style lang="less" scoped>
#weeklyReport {
	.el-form {
		padding: 20px 0;
		/deep/.el-input {
			max-width: 350px;
		}
		/deep/.el-form-item__label {
			line-height: 22px;
			padding: 9px 12px 9px 12px;
		}
		/deep/.el-input-number {
			width: 100%;
			.el-input__inner {
				text-align: left;
			}
		}
		/deep/.el-select {
			width: 100%;
			.el-select__tags {
				max-width: 100%!important;
			}
		}
		/deep/.el-form-item__content .el-input__suffix {
			left: auto;
			right: 10px;
		}
		/deep/.el-range-editor.el-input__inner {
			width: 100%;
			max-width: 350px;
		}
    /deep/.el-date-editor .el-range__icon {
      line-height: 26px;
    }
    /deep/.el-textarea.is-disabled .el-textarea__inner,
    /deep/.el-range-editor.is-disabled input {
      color: #606266;
    }
    .hasStar span {
      color: #F56C6C;
      padding-left: 1px;
    }
    .week-table {
      /deep/td.el-table__cell {
        // padding: 20px 0 0 0;
      }
      /deep/.el-form-item {
        margin-bottom: 20px;
      }
    }
	}
}
</style>


// WEBPACK FOOTER //
// src/view/major/weeklyReportCus/historyDetail.vue